import groq from 'groq'
import pageFields from '../fields/page'
import productFields from '../fields/product'
import mediaFields from '../fields/media'

export default slug => groq`
  *[_type == "productCategoryCollection" && slug.current == "${slug}"][0]{
    ...,
    introMedia {
      ...${mediaFields}
    },
    sections[] {
      ...,
      productCategories[] {
        ...,
        productCategory-> {
          ...,
          products[]-> {
            ...${pageFields},
            ...${productFields}
          },
          backgroundImages[] {
            ...,
            asset-> {
              ...
            }
          },
        }
      },
    }
  }
`
